export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type GQLAcceptSubscriptionInput = {
  accepted: Scalars['Boolean']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type GQLActivateLicenceInput = {
  cameraId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
};

export type GQLActivateLicenceValidation = {
  __typename?: 'ActivateLicenceValidation';
  isBasicLicence: Scalars['Boolean']['output'];
  showLicenceIsAlreadyActiveError: Scalars['Boolean']['output'];
  showLicenceNotFoundError: Scalars['Boolean']['output'];
};

export type GQLActivity = GQLBaseEntity & {
  __typename?: 'Activity';
  camera: GQLCamera;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type GQLAddCameraInput = {
  activationPin: Scalars['String']['input'];
  imei: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type GQLAddCameraValidation = {
  __typename?: 'AddCameraValidation';
  alreadyAssignedError: Scalars['Boolean']['output'];
  /** @deprecated Value should be remove on the next forced app update release */
  legacyAssignedError: Scalars['Boolean']['output'];
};

export type GQLAddCameraValidationInput = {
  activationPin: Scalars['String']['input'];
  imei: Scalars['String']['input'];
};

export type GQLBaseEntity = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type GQLBulkCameraInput = {
  executedBy: Scalars['String']['input'];
};

export type GQLCamera = GQLBaseEntity & {
  __typename?: 'Camera';
  activatedAt: Maybe<Scalars['DateTime']['output']>;
  activationPin: Scalars['String']['output'];
  activities: Array<GQLActivity>;
  basicLicenceInMonths: Scalars['Int']['output'];
  cameraBulkCommands: Array<GQLCameraBulkCommand>;
  cameraId: Scalars['String']['output'];
  captureInterval: GQLCameraCaptureInterval;
  clock: Maybe<Scalars['DateTime']['output']>;
  configurationStatus: GQLCameraConfigurationStatus;
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  hardwareInfo: GQLCameraHardwareInfo;
  id: Scalars['ID']['output'];
  images: Array<GQLImage>;
  inbox: Scalars['String']['output'];
  initialActivationAt: Maybe<Scalars['DateTime']['output']>;
  lastActivity: Maybe<Scalars['DateTime']['output']>;
  lastReceivedImageAt: Maybe<Scalars['DateTime']['output']>;
  licenceInfo: GQLCameraLicenceInfo;
  licences: Array<GQLLicence>;
  location: Maybe<GQLLocation>;
  name: Scalars['String']['output'];
  notifications: Array<GQLNotification>;
  premiumLicenceInMonths: Scalars['Int']['output'];
  status: GQLCameraStatus;
  triggerIntervalInMinutes: Scalars['Int']['output'];
  type: GQLCameraType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  user: Maybe<GQLUser>;
  videoLimitStatus: GQLVideoLimitStatus;
};


export type GQLCameraimagesArgs = {
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
};

export type GQLCameraActionsStatus = {
  __typename?: 'CameraActionsStatus';
  hasRateLimitExceeded: Scalars['Boolean']['output'];
  isAllowedToSendTakeAPhotoSMS: Scalars['Boolean']['output'];
};

export type GQLCameraBulkCommand = GQLBaseEntity & {
  __typename?: 'CameraBulkCommand';
  camera: GQLCamera;
  command: GQLCameraBulkCommandOptions;
  createdAt: Scalars['DateTime']['output'];
  executedBy: Scalars['String']['output'];
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  sentAt: Maybe<Scalars['DateTime']['output']>;
  status: GQLCameraBulkCommandStatus;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export enum GQLCameraBulkCommandOptions {
  ChangeTime = 'ChangeTime'
}

export enum GQLCameraBulkCommandStatus {
  Failed = 'Failed',
  Finished = 'Finished',
  Pending = 'Pending'
}

export type GQLCameraCaptureInterval = {
  __typename?: 'CameraCaptureInterval';
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export enum GQLCameraConfigurationStatus {
  Error = 'Error',
  FinalCheck = 'FinalCheck',
  Finished = 'Finished',
  New = 'New'
}

export type GQLCameraFirmware = {
  __typename?: 'CameraFirmware';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GQLCameraHardwareInfo = {
  __typename?: 'CameraHardwareInfo';
  battery: Maybe<Scalars['Float']['output']>;
  firmware: Scalars['String']['output'];
  imei: Scalars['String']['output'];
  lastUpdated: Maybe<Scalars['DateTime']['output']>;
  msisdn: Scalars['String']['output'];
  networkGeneration: Maybe<GQLNetworkGeneration>;
  signal: Maybe<GQLSignalStrength>;
  sn: Scalars['String']['output'];
  space: Maybe<GQLSpaceInfo>;
  temperature: Maybe<Scalars['Float']['output']>;
};

export type GQLCameraLicenceInfo = {
  __typename?: 'CameraLicenceInfo';
  basicEndDate: Maybe<Scalars['DateTime']['output']>;
  premiumEndDate: Maybe<Scalars['DateTime']['output']>;
};

export enum GQLCameraStatus {
  Active = 'Active',
  Defect = 'Defect',
  Sleep = 'Sleep'
}

export type GQLCameraSummary = {
  __typename?: 'CameraSummary';
  activatedCamerasCount: Scalars['Int']['output'];
  activeSimsCount: Scalars['Int']['output'];
  licenceWillExpireCount: Scalars['Int']['output'];
};

export type GQLCameraSummaryDashboard = {
  __typename?: 'CameraSummaryDashboard';
  activatedCamerasCount: Scalars['Int']['output'];
  activeSimsCount: Scalars['Int']['output'];
  activedSimsTotalCount: Scalars['Int']['output'];
  camerasWithLicencesCount: Scalars['Int']['output'];
  camerasWithoutLicencesCount: Scalars['Int']['output'];
  deletedCamerasCount: Scalars['Int']['output'];
  simsPerUserCount: Scalars['Float']['output'];
};

export enum GQLCameraType {
  RM2 = 'RM2',
  RM3 = 'RM3',
  RM4 = 'RM4',
  RM4ECO = 'RM4ECO',
  RM4ECO_PLUS = 'RM4ECO_PLUS'
}

export type GQLCodeInformation = {
  __typename?: 'CodeInformation';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GQLCreateActivityInput = {
  cameraId: Scalars['ID']['input'];
  createdBy: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type GQLCreateCameraFirmwareInput = {
  name: Scalars['String']['input'];
};

export type GQLCreateCameraHardwareFreeSpaceInfoInput = {
  percent: Scalars['Float']['input'];
  value: Scalars['Float']['input'];
};

export type GQLCreateCameraHardwareInfoInput = {
  battery?: InputMaybe<Scalars['Float']['input']>;
  firmware?: Scalars['String']['input'];
  imei: Scalars['String']['input'];
  msisdn: Scalars['String']['input'];
  networkGeneration?: InputMaybe<GQLNetworkGeneration>;
  signal?: InputMaybe<GQLSignalStrength>;
  sn: Scalars['String']['input'];
  space?: InputMaybe<GQLCreateCameraHardwareSpaceInfoInput>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type GQLCreateCameraHardwareSpaceInfoInput = {
  free: GQLCreateCameraHardwareFreeSpaceInfoInput;
  total: Scalars['Float']['input'];
};

export type GQLCreateCameraInput = {
  activationPin: Scalars['String']['input'];
  basicLicenceInMonths?: Scalars['Int']['input'];
  cameraId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  hardwareInfo: GQLCreateCameraHardwareInfoInput;
  location?: InputMaybe<GQLCreateLocationInput>;
  name: Scalars['String']['input'];
  premiumLicenceInMonths?: Scalars['Int']['input'];
  type: GQLCameraType;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLCreateImageTagInput = {
  name: Scalars['String']['input'];
};

export type GQLCreateLicenceInput = {
  code: Scalars['String']['input'];
  packageId: Scalars['ID']['input'];
  type: GQLLicenceType;
};

export type GQLCreateLicencesInput = {
  count: Scalars['Int']['input'];
  packageId: Scalars['ID']['input'];
  type: GQLLicenceType;
};

export type GQLCreateLocationInput = {
  lat: Scalars['Float']['input'];
  long: Scalars['Float']['input'];
};

export type GQLCreateLogUserLoginInput = {
  createdAt: Scalars['DateTime']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  message: Scalars['String']['input'];
  severityLevel?: GQLSeverityLevel;
  userId: Scalars['String']['input'];
};

export type GQLCreateMarkerInput = {
  location: GQLCreateLocationInput;
  name: Scalars['String']['input'];
  type: GQLMarkerType;
};

export type GQLCreatePackageInput = {
  country: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: GQLPackageType;
  validTimeInMonths: Scalars['Int']['input'];
};

export type GQLCreateSubscriptionInput = {
  email: Scalars['String']['input'];
};

export type GQLCreateTrapAlarmInput = {
  location?: InputMaybe<GQLCreateLocationInput>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  pin: Scalars['String']['input'];
};

export type GQLCreateUserFcmTokenInput = {
  os: GQLOs;
  token: Scalars['String']['input'];
};

export type GQLCreateUserInput = {
  aboReminder: Scalars['Boolean']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  agb: Scalars['Boolean']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  ecg: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  language: GQLUserLanguage;
  lastname: Scalars['String']['input'];
  newsletter: Scalars['Boolean']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type GQLFreeSpaceInfo = {
  __typename?: 'FreeSpaceInfo';
  percent: Scalars['Float']['output'];
  /** Value in GB */
  value: Scalars['Float']['output'];
};

export type GQLImage = GQLBaseEntity & {
  __typename?: 'Image';
  blobName: Scalars['String']['output'];
  camera: GQLCamera;
  capturedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  favorite: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mailedAt: Scalars['DateTime']['output'];
  meta: GQLImageMeta;
  note: Maybe<Scalars['String']['output']>;
  tags: Array<GQLImageTag>;
  thumbnailBlobName: Scalars['String']['output'];
  thumbnailUrl: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  videoAvailable: Scalars['Boolean']['output'];
  videoBlobName: Maybe<Scalars['String']['output']>;
  videoReceivedAt: Maybe<Scalars['DateTime']['output']>;
  videoRequestedAt: Maybe<Scalars['DateTime']['output']>;
  videoUrl: Maybe<Scalars['String']['output']>;
};

export type GQLImageEdge = {
  __typename?: 'ImageEdge';
  cursor: Scalars['String']['output'];
  node: GQLImage;
};

export type GQLImageFilterOption = {
  __typename?: 'ImageFilterOption';
  cameras: Array<GQLCamera>;
  from: Scalars['DateTime']['output'];
  moonPhases: Array<GQLMoonPhase>;
  subscriptions: Array<GQLSubscription>;
  tags: Array<Scalars['String']['output']>;
  to: Scalars['DateTime']['output'];
  types: Array<GQLImageFilterType>;
  weatherCodes: Array<GQLWeatherCode>;
};

export enum GQLImageFilterType {
  Favourites = 'Favourites',
  NoFavourites = 'NoFavourites'
}

export type GQLImageMeta = {
  __typename?: 'ImageMeta';
  temperature: Scalars['Float']['output'];
  weather: Maybe<GQLWeatherInformation>;
};

export type GQLImageSortInput = {
  columnName?: InputMaybe<Scalars['String']['input']>;
  direction?: GQLSortDirection;
};

export type GQLImageTag = GQLBaseEntity & {
  __typename?: 'ImageTag';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type GQLImportLicencesInput = {
  codes: Array<Scalars['String']['input']>;
  packageId: Scalars['ID']['input'];
  type: GQLLicenceType;
};

export type GQLImportedLicenceResult = {
  __typename?: 'ImportedLicenceResult';
  alreadyExists: Array<Scalars['String']['output']>;
  created: Array<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type GQLLicence = GQLBaseEntity & {
  __typename?: 'Licence';
  activatedAt: Maybe<Scalars['DateTime']['output']>;
  activeFrom: Maybe<Scalars['DateTime']['output']>;
  activeTill: Maybe<Scalars['DateTime']['output']>;
  camera: Maybe<GQLCamera>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  package: GQLPackage;
  type: GQLLicenceType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export enum GQLLicenceType {
  Online = 'Online',
  Printed = 'Printed'
}

export type GQLLocation = {
  __typename?: 'Location';
  camera: Maybe<GQLCamera>;
  id: Scalars['ID']['output'];
  lat: Scalars['Float']['output'];
  long: Scalars['Float']['output'];
  marker: Maybe<GQLMarker>;
  territory: Maybe<GQLTerritory>;
  trapAlarm: Maybe<GQLTrapAlarm>;
};

export type GQLLog = {
  __typename?: 'Log';
  camera: Maybe<GQLCamera>;
  createdAt: Scalars['DateTime']['output'];
  executedBy: Maybe<Scalars['String']['output']>;
  groupIdentifier: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: Maybe<GQLUser>;
  licence: Maybe<GQLLicence>;
  message: Scalars['String']['output'];
  notification: Maybe<GQLNotification>;
  receive: Maybe<Scalars['JSON']['output']>;
  relationEntity: GQLRelationEntity;
  relationId: Scalars['ID']['output'];
  send: Maybe<Scalars['JSON']['output']>;
  severityLevel: GQLSeverityLevel;
  user: Maybe<GQLUser>;
};

export type GQLLogUserLogin = {
  __typename?: 'LogUserLogin';
  createdAt: Scalars['DateTime']['output'];
  data: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  severityLevel: GQLSeverityLevel;
  userId: Scalars['ID']['output'];
};

export type GQLMarkNotificationsAsReadInput = {
  types?: Array<GQLNotificationType>;
};

export type GQLMarker = GQLBaseEntity & {
  __typename?: 'Marker';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  location: GQLLocation;
  name: Scalars['String']['output'];
  territory: GQLTerritory;
  type: GQLMarkerType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export enum GQLMarkerType {
  Balzplatz = 'Balzplatz',
  Blattstand = 'Blattstand',
  Bodensitz = 'Bodensitz',
  Brunftplatz = 'Brunftplatz',
  Dachsbau = 'Dachsbau',
  Einstand = 'Einstand',
  EinstiegPirschsteig = 'EinstiegPirschsteig',
  Fuchsbau = 'Fuchsbau',
  Fuetterung = 'Fuetterung',
  Hochstand = 'Hochstand',
  Jagdhuette = 'Jagdhuette',
  Kirrung = 'Kirrung',
  Luderplatz = 'Luderplatz',
  Parkplatz = 'Parkplatz',
  Pass = 'Pass',
  Salzlecke = 'Salzlecke',
  Sitzleiter = 'Sitzleiter',
  Wildwechsel = 'Wildwechsel'
}

export enum GQLMoonPhase {
  FirstQuarter = 'FirstQuarter',
  FullMoon = 'FullMoon',
  LastQuarter = 'LastQuarter',
  NewMoon = 'NewMoon',
  WaningCrescent = 'WaningCrescent',
  WaningGibbous = 'WaningGibbous',
  WaxingCrescent = 'WaxingCrescent',
  WaxingGibbous = 'WaxingGibbous'
}

export type GQLMutation = {
  __typename?: 'Mutation';
  activateLicence: GQLLicence;
  addCamera: GQLCamera;
  addCameraValidation: GQLAddCameraValidation;
  addUserFcmToken: GQLUserFcmToken;
  answerSubscriptionRequest: Scalars['Boolean']['output'];
  cancelSubscription: Scalars['Boolean']['output'];
  createActivity: GQLActivity;
  createCameraAdmin: GQLCamera;
  createCameraFirmwareAdmin: GQLCameraFirmware;
  createLicence: GQLLicence;
  createLicences: Array<GQLLicence>;
  createLog: Scalars['Boolean']['output'];
  createMarker: GQLMarker;
  createPackage: GQLPackage;
  createSubscription: GQLSubscription;
  createTrapAlarm: GQLTrapAlarm;
  createUserAdmin: GQLUser;
  deleteTrapAlarm: Scalars['Boolean']['output'];
  importLicences: GQLImportedLicenceResult;
  loginRegisterLogin: GQLUser;
  loginResetPassword: Maybe<GQLUser>;
  loginSetPassword: GQLUser;
  loginSignUp: GQLUser;
  loginUpdateUserEMail: Maybe<Scalars['String']['output']>;
  markNotificationTypesAsRead: GQLUnreadNotificationCount;
  reconfigureCamera: Scalars['Boolean']['output'];
  reconfigureCameraAdmin: Scalars['Boolean']['output'];
  removeActivity: Scalars['Boolean']['output'];
  removeCamera: Scalars['Boolean']['output'];
  removeCameraAdmin: Scalars['Boolean']['output'];
  removeCameraUserRelationAdmin: Scalars['Boolean']['output'];
  removeImage: Scalars['Boolean']['output'];
  removeImages: Scalars['Boolean']['output'];
  removeImagesByFilter: Scalars['Boolean']['output'];
  removeLicence: Scalars['Boolean']['output'];
  removeMarker: Scalars['Boolean']['output'];
  removeNotification: Scalars['Boolean']['output'];
  removePackage: Scalars['Boolean']['output'];
  removeSubscription: Scalars['Boolean']['output'];
  removeTerritory: Scalars['Boolean']['output'];
  removeUser: Scalars['Boolean']['output'];
  removeUserAdmin: Scalars['Boolean']['output'];
  removeUserFcmToken: Scalars['Boolean']['output'];
  requestVideo: GQLImage;
  restoreUserAdmin: Scalars['Boolean']['output'];
  sendCameraCode: Scalars['Boolean']['output'];
  sendCameraCodeAdmin: Scalars['Boolean']['output'];
  signUpNewsletter: Scalars['Boolean']['output'];
  updateActivity: GQLActivity;
  updateCamera: GQLCamera;
  updateCameraAdmin: GQLCamera;
  updateCameraInboxAdmin: GQLCamera;
  updateCamerasTimeAdmin: Array<GQLCameraBulkCommand>;
  updateImage: GQLImage;
  updateImages: Array<GQLImage>;
  updateLicence: GQLLicence;
  updateLicenceCamera: GQLLicence;
  updateMarker: GQLMarker;
  updateNotification: GQLNotification;
  updatePackage: GQLPackage;
  updateTerritory: GQLTerritory;
  updateTrapAlarm: GQLTrapAlarm;
  updateTrapAlarmAdmin: GQLTrapAlarm;
  updateUser: GQLUser;
  updateUserAdmin: GQLUser;
  updateUserEmail: Scalars['Boolean']['output'];
  updateUserNotificationSettings: GQLUserNotificationSettingResponse;
};


export type GQLMutationactivateLicenceArgs = {
  input: GQLActivateLicenceInput;
};


export type GQLMutationaddCameraArgs = {
  input: GQLAddCameraInput;
};


export type GQLMutationaddCameraValidationArgs = {
  input: GQLAddCameraValidationInput;
};


export type GQLMutationaddUserFcmTokenArgs = {
  input: GQLCreateUserFcmTokenInput;
};


export type GQLMutationanswerSubscriptionRequestArgs = {
  input: GQLAcceptSubscriptionInput;
};


export type GQLMutationcancelSubscriptionArgs = {
  userId: Scalars['ID']['input'];
};


export type GQLMutationcreateActivityArgs = {
  input: GQLCreateActivityInput;
};


export type GQLMutationcreateCameraAdminArgs = {
  input: GQLCreateCameraInput;
};


export type GQLMutationcreateCameraFirmwareAdminArgs = {
  input: GQLCreateCameraFirmwareInput;
};


export type GQLMutationcreateLicenceArgs = {
  input: GQLCreateLicenceInput;
};


export type GQLMutationcreateLicencesArgs = {
  input: GQLCreateLicencesInput;
};


export type GQLMutationcreateLogArgs = {
  input: GQLCreateLogUserLoginInput;
};


export type GQLMutationcreateMarkerArgs = {
  data: GQLCreateMarkerInput;
};


export type GQLMutationcreatePackageArgs = {
  input: GQLCreatePackageInput;
};


export type GQLMutationcreateSubscriptionArgs = {
  input: GQLCreateSubscriptionInput;
};


export type GQLMutationcreateTrapAlarmArgs = {
  input: GQLCreateTrapAlarmInput;
};


export type GQLMutationcreateUserAdminArgs = {
  input: GQLCreateUserInput;
};


export type GQLMutationdeleteTrapAlarmArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationimportLicencesArgs = {
  input: GQLImportLicencesInput;
};


export type GQLMutationloginRegisterLoginArgs = {
  userId: Scalars['ID']['input'];
};


export type GQLMutationloginResetPasswordArgs = {
  email: Scalars['String']['input'];
  loginChallenge?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};


export type GQLMutationloginSetPasswordArgs = {
  password: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type GQLMutationloginSignUpArgs = {
  agb: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  language?: Scalars['String']['input'];
  loginChallenge?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};


export type GQLMutationloginUpdateUserEMailArgs = {
  token: Scalars['String']['input'];
};


export type GQLMutationmarkNotificationTypesAsReadArgs = {
  input: GQLMarkNotificationsAsReadInput;
};


export type GQLMutationreconfigureCameraArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationreconfigureCameraAdminArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationremoveActivityArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationremoveCameraArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationremoveCameraAdminArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationremoveCameraUserRelationAdminArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationremoveImageArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationremoveImagesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type GQLMutationremoveImagesByFilterArgs = {
  cameraIds?: Array<Scalars['ID']['input']>;
  friendId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  moonPhases?: Array<GQLMoonPhase>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  types?: Array<GQLImageFilterType>;
  weatherCodes?: Array<GQLWeatherCode>;
};


export type GQLMutationremoveLicenceArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationremoveMarkerArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationremoveNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationremovePackageArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationremoveSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationremoveUserAdminArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationremoveUserFcmTokenArgs = {
  token: Scalars['String']['input'];
};


export type GQLMutationrequestVideoArgs = {
  imageId: Scalars['ID']['input'];
};


export type GQLMutationrestoreUserAdminArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationsendCameraCodeArgs = {
  input: GQLSimplifyCodeInput;
};


export type GQLMutationsendCameraCodeAdminArgs = {
  input: GQLSimplifyCodeAdminInput;
};


export type GQLMutationupdateActivityArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdateActivityInput;
};


export type GQLMutationupdateCameraArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdateCameraInput;
};


export type GQLMutationupdateCameraAdminArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdateCameraInput;
};


export type GQLMutationupdateCameraInboxAdminArgs = {
  id: Scalars['ID']['input'];
  inbox: Scalars['String']['input'];
};


export type GQLMutationupdateCamerasTimeAdminArgs = {
  input: GQLBulkCameraInput;
};


export type GQLMutationupdateImageArgs = {
  data: GQLUpdateImageInput;
  id: Scalars['ID']['input'];
};


export type GQLMutationupdateImagesArgs = {
  data: GQLUpdateImageInput;
  ids: Array<Scalars['ID']['input']>;
};


export type GQLMutationupdateLicenceArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdateLicenceInput;
};


export type GQLMutationupdateLicenceCameraArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdateLicenceCameraInput;
};


export type GQLMutationupdateMarkerArgs = {
  data: GQLUpdateMarkerInput;
  id: Scalars['ID']['input'];
};


export type GQLMutationupdateNotificationArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdateNotificationInput;
};


export type GQLMutationupdatePackageArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdatePackageInput;
};


export type GQLMutationupdateTerritoryArgs = {
  data: GQLUpdateTerritoryInput;
};


export type GQLMutationupdateTrapAlarmArgs = {
  input: GQLUpdateTrapAlarmInput;
};


export type GQLMutationupdateTrapAlarmAdminArgs = {
  input: GQLUpdateTrapAlarmInput;
};


export type GQLMutationupdateUserArgs = {
  input: GQLUpdateUserInput;
};


export type GQLMutationupdateUserAdminArgs = {
  id: Scalars['ID']['input'];
  input: GQLUpdateUserInput;
};


export type GQLMutationupdateUserEmailArgs = {
  updatedEmail: Scalars['String']['input'];
};


export type GQLMutationupdateUserNotificationSettingsArgs = {
  input: GQLUpdateUserNotificationSettingInput;
};

export enum GQLNetworkGeneration {
  G2 = 'G2',
  G3 = 'G3',
  G4 = 'G4',
  G5 = 'G5'
}

export type GQLNotification = GQLBaseEntity & {
  __typename?: 'Notification';
  camera: Maybe<GQLCamera>;
  createdAt: Scalars['DateTime']['output'];
  friend: Maybe<GQLUser>;
  id: Scalars['ID']['output'];
  image: Maybe<GQLImage>;
  message: Scalars['String']['output'];
  readDate: Maybe<Scalars['DateTime']['output']>;
  routingType: GQLNotificationRoutingType;
  sentDate: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  type: GQLNotificationType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  user: GQLUser;
};

export enum GQLNotificationRoutingType {
  Camera = 'Camera',
  Image = 'Image',
  Info = 'Info'
}

export enum GQLNotificationType {
  CameraInfo = 'CameraInfo',
  Friend = 'Friend',
  Image = 'Image',
  Info = 'Info'
}

export enum GQLOs {
  ANDROID = 'ANDROID',
  IOS = 'IOS'
}

export type GQLPackage = GQLBaseEntity & {
  __typename?: 'Package';
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  licences: Array<GQLLicence>;
  name: Scalars['String']['output'];
  type: GQLPackageType;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  validTimeInMonths: Scalars['Int']['output'];
};

export enum GQLPackageType {
  Basic = 'Basic',
  Premium = 'Premium'
}

export type GQLPageInfo = {
  __typename?: 'PageInfo';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
};

export type GQLPaginatedActivity = {
  __typename?: 'PaginatedActivity';
  nextPage: Maybe<Scalars['Int']['output']>;
  nodes: Array<GQLActivity>;
  previousPage: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Maybe<Scalars['Int']['output']>;
};

export type GQLPaginatedCamera = {
  __typename?: 'PaginatedCamera';
  nextPage: Maybe<Scalars['Int']['output']>;
  nodes: Array<GQLCamera>;
  previousPage: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Maybe<Scalars['Int']['output']>;
};

export type GQLPaginatedCameraBulkCommand = {
  __typename?: 'PaginatedCameraBulkCommand';
  nextPage: Maybe<Scalars['Int']['output']>;
  nodes: Array<GQLCameraBulkCommand>;
  previousPage: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Maybe<Scalars['Int']['output']>;
};

export type GQLPaginatedCameraFirmware = {
  __typename?: 'PaginatedCameraFirmware';
  nextPage: Maybe<Scalars['Int']['output']>;
  nodes: Array<GQLCameraFirmware>;
  previousPage: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Maybe<Scalars['Int']['output']>;
};

export type GQLPaginatedCursorImage = {
  __typename?: 'PaginatedCursorImage';
  edges: Maybe<Array<GQLImageEdge>>;
  pageInfo: Maybe<GQLPageInfo>;
};

export type GQLPaginatedImage = {
  __typename?: 'PaginatedImage';
  nextPage: Maybe<Scalars['Int']['output']>;
  nodes: Array<GQLImage>;
  previousPage: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Maybe<Scalars['Int']['output']>;
};

export type GQLPaginatedLicence = {
  __typename?: 'PaginatedLicence';
  nextPage: Maybe<Scalars['Int']['output']>;
  nodes: Array<GQLLicence>;
  previousPage: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Maybe<Scalars['Int']['output']>;
};

export type GQLPaginatedLog = {
  __typename?: 'PaginatedLog';
  nextPage: Maybe<Scalars['Int']['output']>;
  nodes: Array<GQLLog>;
  previousPage: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Maybe<Scalars['Int']['output']>;
};

export type GQLPaginatedNotification = {
  __typename?: 'PaginatedNotification';
  nextPage: Maybe<Scalars['Int']['output']>;
  nodes: Array<GQLNotification>;
  previousPage: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Maybe<Scalars['Int']['output']>;
};

export type GQLPaginatedPackage = {
  __typename?: 'PaginatedPackage';
  nextPage: Maybe<Scalars['Int']['output']>;
  nodes: Array<GQLPackage>;
  previousPage: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Maybe<Scalars['Int']['output']>;
};

export type GQLPaginatedTrapAlarm = {
  __typename?: 'PaginatedTrapAlarm';
  nextPage: Maybe<Scalars['Int']['output']>;
  nodes: Array<GQLTrapAlarm>;
  previousPage: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Maybe<Scalars['Int']['output']>;
};

export type GQLPaginatedUser = {
  __typename?: 'PaginatedUser';
  nextPage: Maybe<Scalars['Int']['output']>;
  nodes: Array<GQLUser>;
  previousPage: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Maybe<Scalars['Int']['output']>;
};

export type GQLPaginatedUserLog = {
  __typename?: 'PaginatedUserLog';
  nextPage: Maybe<Scalars['Int']['output']>;
  nodes: Array<GQLLogUserLogin>;
  previousPage: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Maybe<Scalars['Int']['output']>;
};

export type GQLQuery = {
  __typename?: 'Query';
  activateLicenceValidation: GQLActivateLicenceValidation;
  activitiesAdmin: GQLPaginatedActivity;
  activityAdmin: GQLActivity;
  camera: GQLCamera;
  cameraActionsStatus: GQLCameraActionsStatus;
  cameraAdmin: GQLCamera;
  cameraBulkCommandsAdmin: GQLPaginatedCameraBulkCommand;
  cameraByHardwareInfoAdmin: GQLCamera;
  cameraSummaryAdmin: GQLCameraSummary;
  cameraSummaryDashboardAdmin: GQLCameraSummaryDashboard;
  cameras: GQLPaginatedCamera;
  camerasAdmin: GQLPaginatedCamera;
  camerasFirmwareAdmin: GQLPaginatedCameraFirmware;
  image: GQLImage;
  imageCursor: GQLPaginatedCursorImage;
  imageFilterOptions: GQLImageFilterOption;
  images: GQLPaginatedImage;
  imagesAdmin: GQLPaginatedImage;
  imagesCursor: GQLPaginatedCursorImage;
  invitations: Array<GQLSubscription>;
  lastReceivedLogAdmin: Maybe<GQLLog>;
  licenceAdmin: GQLLicence;
  licenceExportAdmin: GQLPaginatedLicence;
  licences: GQLPaginatedLicence;
  licencesAdmin: GQLPaginatedLicence;
  loginUserByCredentials: Maybe<GQLUser>;
  loginUserByEmail: Maybe<GQLUser>;
  loginUserById: Maybe<GQLUser>;
  loginUserByIdAndPassword: Maybe<GQLUser>;
  loginUserByToken: Maybe<GQLUser>;
  loginValidatePassword: GQLValidatePassword;
  logsAdmin: GQLPaginatedLog;
  logsByGroupIdentifierAdmin: Array<GQLLog>;
  me: GQLUser;
  notifications: GQLPaginatedNotification;
  package: GQLPackage;
  packages: GQLPaginatedPackage;
  simplifySMSCodesAdmin: GQLSimplifySMSCodes;
  subscriberCamera: GQLCamera;
  subscriberCameras: GQLPaginatedCamera;
  subscriberTerritory: Maybe<GQLTerritory>;
  subscriberUser: GQLUser;
  subscriptionRequests: Array<GQLSubscription>;
  subscriptions: Array<GQLSubscription>;
  trapAlarm: GQLTrapAlarm;
  trapAlarmAdmin: GQLTrapAlarm;
  trapAlarms: GQLPaginatedTrapAlarm;
  trapAlarmsAdmin: GQLPaginatedTrapAlarm;
  unreadNotificationCount: GQLUnreadNotificationCount;
  userAdmin: GQLUser;
  userLicencesAdmin: GQLPaginatedLicence;
  userLogsAdmin: GQLPaginatedUserLog;
  userNotificationSettings: GQLUserNotificationSettingResponse;
  userSummaryAdmin: GQLUserSummary;
  userSummaryDashboardAdmin: GQLUserSummaryDashboard;
  usersListAdmin: GQLPaginatedUser;
};


export type GQLQueryactivateLicenceValidationArgs = {
  input: GQLActivateLicenceInput;
};


export type GQLQueryactivitiesAdminArgs = {
  cameraId: Scalars['ID']['input'];
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
};


export type GQLQueryactivityAdminArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerycameraArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerycameraActionsStatusArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerycameraAdminArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerycameraBulkCommandsAdminArgs = {
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
  status?: InputMaybe<GQLCameraBulkCommandStatus>;
};


export type GQLQuerycameraByHardwareInfoAdminArgs = {
  msisdn: Scalars['String']['input'];
  sn: Scalars['String']['input'];
};


export type GQLQuerycamerasArgs = {
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
};


export type GQLQuerycamerasAdminArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  isRoamingSim?: InputMaybe<Scalars['Boolean']['input']>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
  status?: InputMaybe<GQLCameraStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type GQLQuerycamerasFirmwareAdminArgs = {
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
};


export type GQLQueryimageArgs = {
  friendId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type GQLQueryimageCursorArgs = {
  cameraIds?: Array<Scalars['ID']['input']>;
  friendId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  moonPhases?: Array<GQLMoonPhase>;
  sort?: InputMaybe<GQLImageSortInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  types?: Array<GQLImageFilterType>;
  weatherCodes?: Array<GQLWeatherCode>;
};


export type GQLQueryimageFilterOptionsArgs = {
  friendId?: InputMaybe<Scalars['ID']['input']>;
};


export type GQLQueryimagesArgs = {
  cameraIds?: Array<Scalars['ID']['input']>;
  friendId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  moonPhases?: Array<GQLMoonPhase>;
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLImageSortInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  types?: Array<GQLImageFilterType>;
  weatherCodes?: Array<GQLWeatherCode>;
};


export type GQLQueryimagesAdminArgs = {
  cameraId: Scalars['ID']['input'];
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
};


export type GQLQueryimagesCursorArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  cameraIds?: Array<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  friendId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  moonPhases?: Array<GQLMoonPhase>;
  sort?: InputMaybe<GQLImageSortInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  types?: Array<GQLImageFilterType>;
  weatherCodes?: Array<GQLWeatherCode>;
};


export type GQLQuerylastReceivedLogAdminArgs = {
  cameraId: Scalars['ID']['input'];
};


export type GQLQuerylicenceAdminArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerylicenceExportAdminArgs = {
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
};


export type GQLQuerylicencesArgs = {
  cameraId: Scalars['ID']['input'];
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
};


export type GQLQuerylicencesAdminArgs = {
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  cameraId?: InputMaybe<Scalars['ID']['input']>;
  cameraIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  packageType?: InputMaybe<GQLPackageType>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
};


export type GQLQueryloginUserByCredentialsArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type GQLQueryloginUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type GQLQueryloginUserByIdArgs = {
  userId: Scalars['ID']['input'];
};


export type GQLQueryloginUserByIdAndPasswordArgs = {
  id: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type GQLQueryloginUserByTokenArgs = {
  token: Scalars['String']['input'];
};


export type GQLQueryloginValidatePasswordArgs = {
  password: Scalars['String']['input'];
};


export type GQLQuerylogsAdminArgs = {
  cameraId?: InputMaybe<Scalars['ID']['input']>;
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  licenceId?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notificationId?: InputMaybe<Scalars['ID']['input']>;
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type GQLQuerylogsByGroupIdentifierAdminArgs = {
  groupIdentifier: Scalars['String']['input'];
};


export type GQLQuerynotificationsArgs = {
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
  types?: Array<GQLNotificationType>;
};


export type GQLQuerypackageArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerypackagesArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
  type?: InputMaybe<GQLPackageType>;
};


export type GQLQuerysimplifySMSCodesAdminArgs = {
  type: GQLCameraType;
};


export type GQLQuerysubscriberCameraArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type GQLQuerysubscriberCamerasArgs = {
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
  userId: Scalars['ID']['input'];
};


export type GQLQuerysubscriberTerritoryArgs = {
  userId: Scalars['ID']['input'];
};


export type GQLQuerysubscriberUserArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerytrapAlarmArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerytrapAlarmAdminArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQuerytrapAlarmsArgs = {
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
};


export type GQLQuerytrapAlarmsAdminArgs = {
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type GQLQueryuserAdminArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryuserLicencesAdminArgs = {
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
  userId: Scalars['ID']['input'];
};


export type GQLQueryuserLogsAdminArgs = {
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
  userId: Scalars['ID']['input'];
};


export type GQLQueryusersListAdminArgs = {
  cameraStatus?: InputMaybe<GQLCameraStatus>;
  country?: InputMaybe<Scalars['String']['input']>;
  page?: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  size?: Scalars['Int']['input'];
  sort?: InputMaybe<GQLSortInput>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GQLRelationEntity {
  Camera = 'Camera',
  Image = 'Image',
  Licence = 'Licence',
  Notification = 'Notification',
  User = 'User'
}

export enum GQLSeverityLevel {
  Error = 'Error',
  Information = 'Information',
  Warning = 'Warning'
}

export enum GQLSignalStrength {
  Good = 'Good',
  Normal = 'Normal',
  Weak = 'Weak'
}

export type GQLSimplifyCodeAdminInput = {
  cameraId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
  executedBy: Scalars['String']['input'];
};

export type GQLSimplifyCodeInput = {
  cameraId: Scalars['ID']['input'];
  code: GQLSimplifySMSCode;
};

export enum GQLSimplifySMSCode {
  FactoryReset = 'FactoryReset',
  FormatSDCard = 'FormatSDCard',
  GetBattery = 'GetBattery',
  GetCameraLocation = 'GetCameraLocation',
  GetCameraSettings = 'GetCameraSettings',
  GetDateAndTimeOfTheOldestPicture = 'GetDateAndTimeOfTheOldestPicture',
  GetInformation = 'GetInformation',
  GetPIRSettings = 'GetPIRSettings',
  GetSignalStrength = 'GetSignalStrength',
  GetSpace = 'GetSpace',
  GetSystemSettings = 'GetSystemSettings',
  GetTemperature = 'GetTemperature',
  GetVersion = 'GetVersion',
  PhotoBurst1 = 'PhotoBurst1',
  PhotoBurst2 = 'PhotoBurst2',
  PhotoBurst3 = 'PhotoBurst3',
  SendPicturyViaGPRS = 'SendPicturyViaGPRS',
  SendPicturyViaMMS = 'SendPicturyViaMMS',
  SendPicuteToBoth = 'SendPicuteToBoth',
  SendPicuteToEmail = 'SendPicuteToEmail',
  SendPicuteToPhone = 'SendPicuteToPhone',
  SetCameModeToPhoto = 'SetCameModeToPhoto',
  SetCameModeToVideo = 'SetCameModeToVideo',
  SetGSMStatusAwake = 'SetGSMStatusAwake',
  SetGSMStatusSleep = 'SetGSMStatusSleep',
  SetPhotoSize3MP = 'SetPhotoSize3MP',
  SetPhotoSize5MP = 'SetPhotoSize5MP',
  SetPhotoSize8MP = 'SetPhotoSize8MP',
  SetVideoResolutionToQVGA = 'SetVideoResolutionToQVGA',
  SetVideoResolutionToVGA = 'SetVideoResolutionToVGA',
  TakeAPhoto = 'TakeAPhoto',
  TakeAlwaysPhotos = 'TakeAlwaysPhotos'
}

export type GQLSimplifySMSCodes = {
  __typename?: 'SimplifySMSCodes';
  quick: Array<GQLCodeInformation>;
  template: Array<GQLCodeInformation>;
};

export enum GQLSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type GQLSortInput = {
  columnName: Scalars['String']['input'];
  direction?: GQLSortDirection;
};

export type GQLSpaceInfo = {
  __typename?: 'SpaceInfo';
  free: GQLFreeSpaceInfo;
  /** Value in GB */
  total: Scalars['Float']['output'];
};

export type GQLSubscription = GQLBaseEntity & {
  __typename?: 'Subscription';
  acceptedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  for: Maybe<GQLUser>;
  from: GQLUser;
  id: Scalars['ID']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
};

export type GQLTerritory = GQLBaseEntity & {
  __typename?: 'Territory';
  area: Array<GQLLocation>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  markers: Array<GQLMarker>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  user: GQLUser;
};

export type GQLTrapAlarm = GQLBaseEntity & {
  __typename?: 'TrapAlarm';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  location: Maybe<GQLLocation>;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  pin: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  user: GQLUser;
};

export type GQLUnreadNotificationCount = {
  __typename?: 'UnreadNotificationCount';
  cameraInfo: Scalars['Int']['output'];
  friend: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  image: Scalars['Int']['output'];
  info: Scalars['Int']['output'];
};

export type GQLUpdateActivityInput = {
  cameraId?: InputMaybe<Scalars['ID']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateCameraCaptureIntervalInput = {
  /** HH:MM */
  from?: InputMaybe<Scalars['String']['input']>;
  /** HH:MM */
  to?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateCameraHardwareInfoInput = {
  battery?: InputMaybe<Scalars['Float']['input']>;
  firmware?: InputMaybe<Scalars['String']['input']>;
  imei?: InputMaybe<Scalars['String']['input']>;
  msisdn?: InputMaybe<Scalars['String']['input']>;
  networkGeneration?: InputMaybe<GQLNetworkGeneration>;
  signal?: InputMaybe<GQLSignalStrength>;
  sn?: InputMaybe<Scalars['String']['input']>;
  space?: InputMaybe<GQLCreateCameraHardwareSpaceInfoInput>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type GQLUpdateCameraInput = {
  activationPin?: InputMaybe<Scalars['String']['input']>;
  basicLicenceInMonths?: InputMaybe<Scalars['Int']['input']>;
  cameraId?: InputMaybe<Scalars['String']['input']>;
  captureInterval?: InputMaybe<GQLUpdateCameraCaptureIntervalInput>;
  clock?: InputMaybe<Scalars['DateTime']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  hardwareInfo?: InputMaybe<GQLUpdateCameraHardwareInfoInput>;
  location?: InputMaybe<GQLCreateLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  premiumLicenceInMonths?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<GQLCameraStatus>;
  triggerIntervalInMinutes?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<GQLCameraType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLUpdateImageInput = {
  favorite?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<GQLCreateImageTagInput>>;
};

export type GQLUpdateLicenceCameraInput = {
  cameraId: Scalars['ID']['input'];
};

export type GQLUpdateLicenceInput = {
  activatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTill?: InputMaybe<Scalars['DateTime']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  packageId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<GQLLicenceType>;
};

export type GQLUpdateMarkerInput = {
  location?: InputMaybe<GQLCreateLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GQLMarkerType>;
};

export type GQLUpdateNotificationInput = {
  readDate?: InputMaybe<Scalars['DateTime']['input']>;
  sentDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GQLUpdatePackageInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GQLPackageType>;
  validTimeInMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLUpdateTerritoryInput = {
  area: Array<GQLCreateLocationInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type GQLUpdateTrapAlarmInput = {
  id: Scalars['ID']['input'];
  location?: InputMaybe<GQLCreateLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateUserInput = {
  aboReminder?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  agb?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  ecg?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<GQLUserLanguage>;
  lastValidated?: InputMaybe<Scalars['DateTime']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  notificationSettings?: InputMaybe<GQLUpdateUserNotificationSettingInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type GQLUpdateUserNotificationSettingInput = {
  cameraInfos?: InputMaybe<Scalars['Boolean']['input']>;
  friends?: InputMaybe<Scalars['Boolean']['input']>;
  mailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  newImages?: InputMaybe<Scalars['Boolean']['input']>;
  newsOffers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLUser = GQLBaseEntity & {
  __typename?: 'User';
  aboReminder: Scalars['Boolean']['output'];
  address: Maybe<Scalars['String']['output']>;
  agb: Scalars['Boolean']['output'];
  cameras: Array<GQLCamera>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  ecg: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  firstname: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Maybe<Scalars['String']['output']>;
  invitations: Array<GQLSubscription>;
  isActivated: Scalars['Boolean']['output'];
  language: Maybe<GQLUserLanguage>;
  lastLogin: Maybe<Scalars['DateTime']['output']>;
  lastValidated: Maybe<Scalars['DateTime']['output']>;
  lastname: Maybe<Scalars['String']['output']>;
  logins: Scalars['Int']['output'];
  newsletter: Scalars['Boolean']['output'];
  notificationSettings: GQLUserNotificationSetting;
  notifications: Array<GQLNotification>;
  phone: Maybe<Scalars['String']['output']>;
  subscriptionRequests: Array<GQLSubscription>;
  subscriptions: Array<GQLSubscription>;
  territory: GQLTerritory;
  tokenData: Maybe<Scalars['String']['output']>;
  trapAlarms: Array<GQLTrapAlarm>;
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
};

export type GQLUserFcmToken = GQLBaseEntity & {
  __typename?: 'UserFcmToken';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  os: GQLOs;
  token: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['DateTime']['output']>;
  user: GQLUser;
};

export enum GQLUserLanguage {
  de = 'de',
  en = 'en',
  fr = 'fr',
  hr = 'hr',
  hu = 'hu',
  sl = 'sl'
}

export type GQLUserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  cameraInfos: Scalars['Boolean']['output'];
  friends: Scalars['Boolean']['output'];
  mailNotifications: Scalars['Boolean']['output'];
  newImages: Scalars['Boolean']['output'];
  newsOffers: Scalars['Boolean']['output'];
};

export type GQLUserNotificationSettingResponse = {
  __typename?: 'UserNotificationSettingResponse';
  cameraInfos: Scalars['Boolean']['output'];
  friends: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mailNotifications: Scalars['Boolean']['output'];
  newImages: Scalars['Boolean']['output'];
  newsOffers: Scalars['Boolean']['output'];
};

export type GQLUserSummary = {
  __typename?: 'UserSummary';
  userCamerasWithLicencesCount: Scalars['Int']['output'];
  userCamerasWithoutLicencesCount: Scalars['Int']['output'];
  usersWithLicencesCount: Scalars['Int']['output'];
  usersWithoutLicencesCount: Scalars['Int']['output'];
};

export type GQLUserSummaryDashboard = {
  __typename?: 'UserSummaryDashboard';
  licenceWillExpireCount: Scalars['Int']['output'];
  usersWithActivatedSimCount: Scalars['Int']['output'];
  usersWithLicencesCount: Scalars['Int']['output'];
  usersWithoutLicencesCount: Scalars['Int']['output'];
};

export type GQLValidatePassword = {
  __typename?: 'ValidatePassword';
  isValid: Scalars['Boolean']['output'];
  suggestions: Array<Scalars['String']['output']>;
  warning: Maybe<Scalars['String']['output']>;
};

export type GQLVideoLimitStatus = {
  __typename?: 'VideoLimitStatus';
  remaining: Scalars['Int']['output'];
  resetsAt: Scalars['DateTime']['output'];
  total: Scalars['Int']['output'];
};

export enum GQLWeatherCode {
  Blizzard = 'Blizzard',
  BlowingSnow = 'BlowingSnow',
  Clear = 'Clear',
  Cloudy = 'Cloudy',
  Fog = 'Fog',
  FreezingDrizzle = 'FreezingDrizzle',
  FreezingFog = 'FreezingFog',
  HeavyFreezingDrizzle = 'HeavyFreezingDrizzle',
  HeavyRain = 'HeavyRain',
  HeavyRainAtTimes = 'HeavyRainAtTimes',
  HeavySnow = 'HeavySnow',
  IcePellets = 'IcePellets',
  LightDrizzle = 'LightDrizzle',
  LightFreezingRain = 'LightFreezingRain',
  LightRain = 'LightRain',
  LightRainShower = 'LightRainShower',
  LightShowersOfIcePellets = 'LightShowersOfIcePellets',
  LightSleet = 'LightSleet',
  LightSleetShowers = 'LightSleetShowers',
  LightSnow = 'LightSnow',
  LightSnowShowers = 'LightSnowShowers',
  Mist = 'Mist',
  ModerateOrHeavyFreezingRain = 'ModerateOrHeavyFreezingRain',
  ModerateOrHeavyRainInAreaWithThunder = 'ModerateOrHeavyRainInAreaWithThunder',
  ModerateOrHeavyRainShower = 'ModerateOrHeavyRainShower',
  ModerateOrHeavyShowersOfIcePellets = 'ModerateOrHeavyShowersOfIcePellets',
  ModerateOrHeavySleet = 'ModerateOrHeavySleet',
  ModerateOrHeavySleetShowers = 'ModerateOrHeavySleetShowers',
  ModerateOrHeavySnowInAreaWithThunder = 'ModerateOrHeavySnowInAreaWithThunder',
  ModerateOrHeavySnowShowers = 'ModerateOrHeavySnowShowers',
  ModerateRain = 'ModerateRain',
  ModerateRainAtTimes = 'ModerateRainAtTimes',
  ModerateSnow = 'ModerateSnow',
  Overcast = 'Overcast',
  PartlyCloudy = 'PartlyCloudy',
  PatchyFreezingDrizzlePossible = 'PatchyFreezingDrizzlePossible',
  PatchyHeavySnow = 'PatchyHeavySnow',
  PatchyLightDrizzle = 'PatchyLightDrizzle',
  PatchyLightRain = 'PatchyLightRain',
  PatchyLightRainInAreaWithThunder = 'PatchyLightRainInAreaWithThunder',
  PatchyLightSnow = 'PatchyLightSnow',
  PatchyLightSnowInAreaWithThunder = 'PatchyLightSnowInAreaWithThunder',
  PatchyModerateSnow = 'PatchyModerateSnow',
  PatchyRainPossible = 'PatchyRainPossible',
  PatchySleetPossible = 'PatchySleetPossible',
  PatchySnowPossible = 'PatchySnowPossible',
  ThunderyOutbreaksPossible = 'ThunderyOutbreaksPossible',
  TorrentialRainShower = 'TorrentialRainShower'
}

export type GQLWeatherInformation = {
  __typename?: 'WeatherInformation';
  moonPhase: Maybe<GQLMoonPhase>;
  moonrise: Maybe<Scalars['DateTime']['output']>;
  moonset: Maybe<Scalars['DateTime']['output']>;
  sunrise: Maybe<Scalars['DateTime']['output']>;
  sunset: Maybe<Scalars['DateTime']['output']>;
  weatherCode: Maybe<GQLWeatherCode>;
  windDirection: Maybe<GQLWindDirection>;
  windspeedKmph: Maybe<Scalars['Int']['output']>;
};

export enum GQLWindDirection {
  E = 'E',
  ENE = 'ENE',
  ESE = 'ESE',
  N = 'N',
  NE = 'NE',
  NNE = 'NNE',
  NNW = 'NNW',
  NW = 'NW',
  S = 'S',
  SE = 'SE',
  SSE = 'SSE',
  SSW = 'SSW',
  SW = 'SW',
  W = 'W',
  WNW = 'WNW',
  WSW = 'WSW'
}

export type GQLCameraByHardwareInfoAdminQueryVariables = Exact<{
  sn: Scalars['String']['input'];
  msisdn: Scalars['String']['input'];
}>;


export type GQLCameraByHardwareInfoAdminQuery = { __typename?: 'Query', cameraByHardwareInfoAdmin: { __typename?: 'Camera', id: string, hardwareInfo: { __typename?: 'CameraHardwareInfo', sn: string, msisdn: string } } };

export type GQLUpdateLicenceCameraMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: GQLUpdateLicenceCameraInput;
}>;


export type GQLUpdateLicenceCameraMutation = { __typename?: 'Mutation', updateLicenceCamera: { __typename?: 'Licence', id: string } };

export type GQLDeleteCodeAdminMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLDeleteCodeAdminMutation = { __typename?: 'Mutation', removeLicence: boolean };

export type GQLRemoveCameraAdminMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLRemoveCameraAdminMutation = { __typename?: 'Mutation', removeCameraAdmin: boolean };

export type GQLReconfigureCameraAdminMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLReconfigureCameraAdminMutation = { __typename?: 'Mutation', reconfigureCameraAdmin: boolean };

export type GQLSelectPackagesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GQLSelectPackagesQuery = { __typename?: 'Query', packages: { __typename?: 'PaginatedPackage', nodes: Array<{ __typename?: 'Package', id: string, name: string }> } };

export type GQLSelectUsersQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GQLSelectUsersQuery = { __typename?: 'Query', usersListAdmin: { __typename?: 'PaginatedUser', nodes: Array<{ __typename?: 'User', id: string, firstname: string | null, lastname: string | null }> } };

export type GQLUpdateCamerasTimeAdminMutationVariables = Exact<{
  input: GQLBulkCameraInput;
}>;


export type GQLUpdateCamerasTimeAdminMutation = { __typename?: 'Mutation', updateCamerasTimeAdmin: Array<{ __typename?: 'CameraBulkCommand', id: string }> };

export type GQLCameraBulkCommandsAdminQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
  status?: InputMaybe<GQLCameraBulkCommandStatus>;
}>;


export type GQLCameraBulkCommandsAdminQuery = { __typename?: 'Query', cameraBulkCommandsAdmin: { __typename?: 'PaginatedCameraBulkCommand', totalCount: number, nextPage: number | null, previousPage: number | null, totalPages: number | null, nodes: Array<{ __typename?: 'CameraBulkCommand', id: string, createdAt: any, executedBy: string, sentAt: any | null, finishedAt: any | null, status: GQLCameraBulkCommandStatus, camera: { __typename?: 'Camera', id: string, name: string } }> } };

export type GQLCodesListAdminQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GQLCodesListAdminQuery = { __typename?: 'Query', licencesAdmin: { __typename?: 'PaginatedLicence', totalCount: number, nextPage: number | null, previousPage: number | null, totalPages: number | null, nodes: Array<{ __typename?: 'Licence', id: string, code: string, activatedAt: any | null, activeFrom: any | null, activeTill: any | null, createdAt: any, type: GQLLicenceType, package: { __typename?: 'Package', name: string } }> } };

export type GQLImportLicencesMutationVariables = Exact<{
  input: GQLImportLicencesInput;
}>;


export type GQLImportLicencesMutation = { __typename?: 'Mutation', importLicences: { __typename?: 'ImportedLicenceResult', created: Array<string>, alreadyExists: Array<string>, errors: Array<string> } };

export type GQLCreateLicenceMutationVariables = Exact<{
  input: GQLCreateLicencesInput;
}>;


export type GQLCreateLicenceMutation = { __typename?: 'Mutation', createLicences: Array<{ __typename?: 'Licence', id: string }> };

export type GQLCodeAdminQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLCodeAdminQuery = { __typename?: 'Query', licenceAdmin: { __typename?: 'Licence', id: string, code: string, activatedAt: any | null, activeFrom: any | null, activeTill: any | null, createdAt: any, type: GQLLicenceType, package: { __typename?: 'Package', name: string } } };

export type GQLCodeFragmentFragment = { __typename?: 'Licence', id: string, code: string, activatedAt: any | null, activeFrom: any | null, activeTill: any | null, createdAt: any, type: GQLLicenceType, package: { __typename?: 'Package', name: string } };

export type GQLCameraSummaryDashboardAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLCameraSummaryDashboardAdminQuery = { __typename?: 'Query', cameraSummaryDashboardAdmin: { __typename?: 'CameraSummaryDashboard', activatedCamerasCount: number, deletedCamerasCount: number, camerasWithLicencesCount: number, camerasWithoutLicencesCount: number } };

export type GQLSimsSummaryDashboardAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLSimsSummaryDashboardAdminQuery = { __typename?: 'Query', cameraSummaryDashboardAdmin: { __typename?: 'CameraSummaryDashboard', activeSimsCount: number, activatedCamerasCount: number, simsPerUserCount: number } };

export type GQLUserSummaryDashboardAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLUserSummaryDashboardAdminQuery = { __typename?: 'Query', userSummaryDashboardAdmin: { __typename?: 'UserSummaryDashboard', usersWithLicencesCount: number, usersWithoutLicencesCount: number, usersWithActivatedSimCount: number, licenceWillExpireCount: number } };

export type GQLCameraSummaryAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLCameraSummaryAdminQuery = { __typename?: 'Query', cameraSummaryAdmin: { __typename?: 'CameraSummary', activeSimsCount: number, activatedCamerasCount: number, licenceWillExpireCount: number } };

export type GQLCamerasAdminQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
  status?: InputMaybe<GQLCameraStatus>;
  country?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  isRoamingSim?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GQLCamerasAdminQuery = { __typename?: 'Query', camerasAdmin: { __typename?: 'PaginatedCamera', totalCount: number, nextPage: number | null, previousPage: number | null, totalPages: number | null, nodes: Array<{ __typename?: 'Camera', id: string, name: string, status: GQLCameraStatus, activatedAt: any | null, country: string, configurationStatus: GQLCameraConfigurationStatus, initialActivationAt: any | null, lastActivity: any | null, hardwareInfo: { __typename?: 'CameraHardwareInfo', imei: string, sn: string, msisdn: string } }> } };

export type GQLCreateCameraAdminMutationVariables = Exact<{
  input: GQLCreateCameraInput;
}>;


export type GQLCreateCameraAdminMutation = { __typename?: 'Mutation', createCameraAdmin: { __typename?: 'Camera', id: string } };

export type GQLCameraAdminQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLCameraAdminQuery = { __typename?: 'Query', cameraAdmin: { __typename?: 'Camera', id: string, activatedAt: any | null, initialActivationAt: any | null, name: string, cameraId: string, activationPin: string, type: GQLCameraType, country: string, status: GQLCameraStatus, configurationStatus: GQLCameraConfigurationStatus, lastReceivedImageAt: any | null, basicLicenceInMonths: number, premiumLicenceInMonths: number, licenceInfo: { __typename?: 'CameraLicenceInfo', basicEndDate: any | null, premiumEndDate: any | null }, user: { __typename?: 'User', id: string, firstname: string | null, lastname: string | null, email: string } | null, hardwareInfo: { __typename?: 'CameraHardwareInfo', imei: string, sn: string, msisdn: string, firmware: string } } };

export type GQLRemoveCameraUserRelationAdminMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLRemoveCameraUserRelationAdminMutation = { __typename?: 'Mutation', removeCameraUserRelationAdmin: boolean };

export type GQLUpdateCameraAdminMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: GQLUpdateCameraInput;
}>;


export type GQLUpdateCameraAdminMutation = { __typename?: 'Mutation', updateCameraAdmin: { __typename?: 'Camera', id: string, activatedAt: any | null, initialActivationAt: any | null, name: string, cameraId: string, activationPin: string, type: GQLCameraType, country: string, status: GQLCameraStatus, configurationStatus: GQLCameraConfigurationStatus, lastReceivedImageAt: any | null, basicLicenceInMonths: number, premiumLicenceInMonths: number, licenceInfo: { __typename?: 'CameraLicenceInfo', basicEndDate: any | null, premiumEndDate: any | null }, user: { __typename?: 'User', id: string, firstname: string | null, lastname: string | null, email: string } | null, hardwareInfo: { __typename?: 'CameraHardwareInfo', imei: string, sn: string, msisdn: string, firmware: string } } };

export type GQLLastReceivedLogAdminQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
}>;


export type GQLLastReceivedLogAdminQuery = { __typename?: 'Query', lastReceivedLogAdmin: { __typename?: 'Log', createdAt: any } | null };

export type GQLlicencesAdminQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
}>;


export type GQLlicencesAdminQuery = { __typename?: 'Query', licencesAdmin: { __typename?: 'PaginatedLicence', totalCount: number, totalPages: number | null, nextPage: number | null, previousPage: number | null, nodes: Array<{ __typename?: 'Licence', id: string, code: string, activatedAt: any | null, activeFrom: any | null, activeTill: any | null, package: { __typename?: 'Package', name: string } }> } };

export type GQLSendCameraCodeAdminMutationVariables = Exact<{
  input: GQLSimplifyCodeAdminInput;
}>;


export type GQLSendCameraCodeAdminMutation = { __typename?: 'Mutation', sendCameraCodeAdmin: boolean };

export type GQLSimplifySMSCodesAdminQueryVariables = Exact<{
  type: GQLCameraType;
}>;


export type GQLSimplifySMSCodesAdminQuery = { __typename?: 'Query', simplifySMSCodesAdmin: { __typename?: 'SimplifySMSCodes', quick: Array<{ __typename?: 'CodeInformation', label: string, value: string }>, template: Array<{ __typename?: 'CodeInformation', label: string, value: string }> } };

export type GQLLogsAdminQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type GQLLogsAdminQuery = { __typename?: 'Query', logsAdmin: { __typename?: 'PaginatedLog', totalCount: number, totalPages: number | null, nextPage: number | null, previousPage: number | null, nodes: Array<{ __typename?: 'Log', id: string, send: any | null, receive: any | null, createdAt: any, message: string, executedBy: string | null, groupIdentifier: string | null }> } };

export type GQLLogsByGroupIdentifierAdminQueryVariables = Exact<{
  groupIdentifier: Scalars['String']['input'];
}>;


export type GQLLogsByGroupIdentifierAdminQuery = { __typename?: 'Query', logsByGroupIdentifierAdmin: Array<{ __typename?: 'Log', id: string, send: any | null, receive: any | null, createdAt: any, message: string, executedBy: string | null }> };

export type GQLActivitiesAdminQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
}>;


export type GQLActivitiesAdminQuery = { __typename?: 'Query', activitiesAdmin: { __typename?: 'PaginatedActivity', totalCount: number, totalPages: number | null, nextPage: number | null, previousPage: number | null, nodes: Array<{ __typename?: 'Activity', id: string, message: string, createdBy: string, createdAt: any }> } };

export type GQLCreateActivityAdminMutationVariables = Exact<{
  input: GQLCreateActivityInput;
}>;


export type GQLCreateActivityAdminMutation = { __typename?: 'Mutation', createActivity: { __typename?: 'Activity', id: string } };

export type GQLUpdateActivityAdminMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: GQLUpdateActivityInput;
}>;


export type GQLUpdateActivityAdminMutation = { __typename?: 'Mutation', updateActivity: { __typename?: 'Activity', message: string, createdBy: string } };

export type GQLDeleteActivityAdminMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLDeleteActivityAdminMutation = { __typename?: 'Mutation', removeActivity: boolean };

export type GQLActivityAdminQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLActivityAdminQuery = { __typename?: 'Query', activityAdmin: { __typename?: 'Activity', id: string, createdBy: string, message: string, createdAt: any } };

export type GQLCameraFragmentFragment = { __typename?: 'Camera', id: string, activatedAt: any | null, initialActivationAt: any | null, name: string, cameraId: string, activationPin: string, type: GQLCameraType, country: string, status: GQLCameraStatus, configurationStatus: GQLCameraConfigurationStatus, lastReceivedImageAt: any | null, basicLicenceInMonths: number, premiumLicenceInMonths: number, licenceInfo: { __typename?: 'CameraLicenceInfo', basicEndDate: any | null, premiumEndDate: any | null }, user: { __typename?: 'User', id: string, firstname: string | null, lastname: string | null, email: string } | null, hardwareInfo: { __typename?: 'CameraHardwareInfo', imei: string, sn: string, msisdn: string, firmware: string } };

export type GQLImagesAdminQueryVariables = Exact<{
  cameraId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
}>;


export type GQLImagesAdminQuery = { __typename?: 'Query', imagesAdmin: { __typename?: 'PaginatedImage', totalCount: number, totalPages: number | null, nextPage: number | null, previousPage: number | null, nodes: Array<{ __typename?: 'Image', id: string, mailedAt: any }> } };

export type GQLCreateCameraFirmwareAdminMutationVariables = Exact<{
  input: GQLCreateCameraFirmwareInput;
}>;


export type GQLCreateCameraFirmwareAdminMutation = { __typename?: 'Mutation', createCameraFirmwareAdmin: { __typename?: 'CameraFirmware', id: string } };

export type GQLCamerasFirmwareAdminQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GQLCamerasFirmwareAdminQuery = { __typename?: 'Query', camerasFirmwareAdmin: { __typename?: 'PaginatedCameraFirmware', totalCount: number, nextPage: number | null, previousPage: number | null, totalPages: number | null, nodes: Array<{ __typename?: 'CameraFirmware', id: string, name: string }> } };

export type GQLPackagesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GQLPackageType>;
}>;


export type GQLPackagesQuery = { __typename?: 'Query', packages: { __typename?: 'PaginatedPackage', totalCount: number, nextPage: number | null, previousPage: number | null, totalPages: number | null, nodes: Array<{ __typename?: 'Package', id: string, name: string, description: string, country: string, validTimeInMonths: number, type: GQLPackageType, createdAt: any }> } };

export type GQLCreatePackageMutationVariables = Exact<{
  input: GQLCreatePackageInput;
}>;


export type GQLCreatePackageMutation = { __typename?: 'Mutation', createPackage: { __typename?: 'Package', id: string } };

export type GQLUpdatePackageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: GQLUpdatePackageInput;
}>;


export type GQLUpdatePackageMutation = { __typename?: 'Mutation', updatePackage: { __typename?: 'Package', id: string, country: string, name: string, description: string, type: GQLPackageType, validTimeInMonths: number, createdAt: any } };

export type GQLPackageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLPackageQuery = { __typename?: 'Query', package: { __typename?: 'Package', id: string, country: string, name: string, description: string, type: GQLPackageType, validTimeInMonths: number, createdAt: any } };

export type GQLPackageFragmentFragment = { __typename?: 'Package', id: string, country: string, name: string, description: string, type: GQLPackageType, validTimeInMonths: number, createdAt: any };

export type GQLlicenceAdminFragmentFragment = { __typename?: 'Licence', id: string, code: string, activatedAt: any | null, activeFrom: any | null, activeTill: any | null, package: { __typename?: 'Package', name: string }, camera: { __typename?: 'Camera', id: string, cameraId: string, user: { __typename?: 'User', id: string, firstname: string | null, lastname: string | null } | null } | null };

export type GQLPurchasesListAdminQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
  activated?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  packageType?: InputMaybe<GQLPackageType>;
}>;


export type GQLPurchasesListAdminQuery = { __typename?: 'Query', licencesAdmin: { __typename?: 'PaginatedLicence', totalCount: number, nextPage: number | null, previousPage: number | null, totalPages: number | null, nodes: Array<{ __typename?: 'Licence', id: string, code: string, activatedAt: any | null, activeFrom: any | null, activeTill: any | null, package: { __typename?: 'Package', name: string }, camera: { __typename?: 'Camera', id: string, cameraId: string, user: { __typename?: 'User', id: string, firstname: string | null, lastname: string | null } | null } | null }> } };

export type GQLPurchasesExportListAdminQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GQLPurchasesExportListAdminQuery = { __typename?: 'Query', licenceExportAdmin: { __typename?: 'PaginatedLicence', totalCount: number, nextPage: number | null, previousPage: number | null, totalPages: number | null, nodes: Array<{ __typename?: 'Licence', id: string, code: string, activatedAt: any | null, activeFrom: any | null, activeTill: any | null, package: { __typename?: 'Package', name: string }, camera: { __typename?: 'Camera', id: string, cameraId: string, user: { __typename?: 'User', id: string, firstname: string | null, lastname: string | null } | null } | null }> } };

export type GQLPurchaseAdminQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLPurchaseAdminQuery = { __typename?: 'Query', licenceAdmin: { __typename?: 'Licence', id: string, code: string, activatedAt: any | null, activeFrom: any | null, activeTill: any | null, package: { __typename?: 'Package', id: string, name: string, description: string, type: GQLPackageType, validTimeInMonths: number }, camera: { __typename?: 'Camera', id: string, name: string, country: string, status: GQLCameraStatus, hardwareInfo: { __typename?: 'CameraHardwareInfo', imei: string, sn: string, msisdn: string }, user: { __typename?: 'User', id: string, firstname: string | null, lastname: string | null, email: string } | null } | null } };

export type GQLPurchaseFragmentFragment = { __typename?: 'Licence', id: string, code: string, activatedAt: any | null, activeFrom: any | null, activeTill: any | null, package: { __typename?: 'Package', id: string, name: string, description: string, type: GQLPackageType, validTimeInMonths: number }, camera: { __typename?: 'Camera', id: string, name: string, country: string, status: GQLCameraStatus, hardwareInfo: { __typename?: 'CameraHardwareInfo', imei: string, sn: string, msisdn: string }, user: { __typename?: 'User', id: string, firstname: string | null, lastname: string | null, email: string } | null } | null };

export type GQLTrapAlarmsAdminQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type GQLTrapAlarmsAdminQuery = { __typename?: 'Query', trapAlarmsAdmin: { __typename?: 'PaginatedTrapAlarm', totalCount: number, nextPage: number | null, previousPage: number | null, totalPages: number | null, nodes: Array<{ __typename?: 'TrapAlarm', id: string, name: string, phone: string, pin: string, user: { __typename?: 'User', id: string, firstname: string | null, lastname: string | null } }> } };

export type GQLUpdateTrapAlarmAdminMutationVariables = Exact<{
  input: GQLUpdateTrapAlarmInput;
}>;


export type GQLUpdateTrapAlarmAdminMutation = { __typename?: 'Mutation', updateTrapAlarmAdmin: { __typename?: 'TrapAlarm', id: string, name: string, phone: string, pin: string } };

export type GQLTrapAlarmAdminQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLTrapAlarmAdminQuery = { __typename?: 'Query', trapAlarmAdmin: { __typename?: 'TrapAlarm', id: string, name: string, phone: string, pin: string } };

export type GQLUsersListAdminQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  cameraStatus?: InputMaybe<GQLCameraStatus>;
  size?: InputMaybe<Scalars['Int']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GQLUsersListAdminQuery = { __typename?: 'Query', usersListAdmin: { __typename?: 'PaginatedUser', totalCount: number, nextPage: number | null, previousPage: number | null, totalPages: number | null, nodes: Array<{ __typename?: 'User', id: string, firstname: string | null, lastname: string | null, email: string, address: string | null, zipCode: string | null, city: string | null, phone: string | null, country: string | null, agb: boolean, newsletter: boolean, aboReminder: boolean, ecg: boolean, createdAt: any, updatedAt: any | null, lastValidated: any | null, cameras: Array<{ __typename?: 'Camera', id: string, status: GQLCameraStatus }> }> } };

export type GQLRestoreUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLRestoreUserMutation = { __typename?: 'Mutation', restoreUserAdmin: boolean };

export type GQLUserSummaryAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLUserSummaryAdminQuery = { __typename?: 'Query', userSummaryAdmin: { __typename?: 'UserSummary', usersWithLicencesCount: number, usersWithoutLicencesCount: number, userCamerasWithLicencesCount: number, userCamerasWithoutLicencesCount: number } };

export type GQLUserCamerasAdminQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
}>;


export type GQLUserCamerasAdminQuery = { __typename?: 'Query', camerasAdmin: { __typename?: 'PaginatedCamera', totalCount: number, totalPages: number | null, nextPage: number | null, previousPage: number | null, nodes: Array<{ __typename?: 'Camera', id: string, name: string, activatedAt: any | null, hardwareInfo: { __typename?: 'CameraHardwareInfo', imei: string, msisdn: string } }> } };

export type GQLUpdateUserAdminMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: GQLUpdateUserInput;
}>;


export type GQLUpdateUserAdminMutation = { __typename?: 'Mutation', updateUserAdmin: { __typename?: 'User', id: string, firstname: string | null, lastname: string | null, email: string, address: string | null, zipCode: string | null, city: string | null, phone: string | null, country: string | null, agb: boolean, newsletter: boolean, aboReminder: boolean, ecg: boolean, cameras: Array<{ __typename?: 'Camera', id: string, name: string, activatedAt: any | null, hardwareInfo: { __typename?: 'CameraHardwareInfo', imei: string, msisdn: string } }> } };

export type GQLUserLicencesAdminQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
}>;


export type GQLUserLicencesAdminQuery = { __typename?: 'Query', userLicencesAdmin: { __typename?: 'PaginatedLicence', totalCount: number, totalPages: number | null, nextPage: number | null, previousPage: number | null, nodes: Array<{ __typename?: 'Licence', id: string, activatedAt: any | null, code: string, activeFrom: any | null, activeTill: any | null, package: { __typename?: 'Package', name: string }, camera: { __typename?: 'Camera', cameraId: string } | null }> } };

export type GQLUserLogFragmentFragment = { __typename?: 'LogUserLogin', id: string, data: any | null, message: string, severityLevel: GQLSeverityLevel, createdAt: any, userId: string };

export type GQLUserLogsAdminQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
}>;


export type GQLUserLogsAdminQuery = { __typename?: 'Query', userLogsAdmin: { __typename?: 'PaginatedUserLog', totalCount: number, totalPages: number | null, nextPage: number | null, previousPage: number | null, nodes: Array<{ __typename?: 'LogUserLogin', id: string, data: any | null, message: string, severityLevel: GQLSeverityLevel, createdAt: any, userId: string }> } };

export type GQLTrapAlarmsUserAdminQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<GQLSortInput>;
}>;


export type GQLTrapAlarmsUserAdminQuery = { __typename?: 'Query', trapAlarmsAdmin: { __typename?: 'PaginatedTrapAlarm', totalCount: number, nextPage: number | null, previousPage: number | null, totalPages: number | null, nodes: Array<{ __typename?: 'TrapAlarm', id: string, name: string, phone: string, pin: string }> } };

export type GQLUserAdminQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GQLUserAdminQuery = { __typename?: 'Query', userAdmin: { __typename?: 'User', id: string, firstname: string | null, lastname: string | null, email: string, address: string | null, zipCode: string | null, city: string | null, phone: string | null, country: string | null, agb: boolean, newsletter: boolean, aboReminder: boolean, ecg: boolean, cameras: Array<{ __typename?: 'Camera', id: string, name: string, activatedAt: any | null, hardwareInfo: { __typename?: 'CameraHardwareInfo', imei: string, msisdn: string } }> } };

export type GQLUserFragmentFragment = { __typename?: 'User', id: string, firstname: string | null, lastname: string | null, email: string, address: string | null, zipCode: string | null, city: string | null, phone: string | null, country: string | null, agb: boolean, newsletter: boolean, aboReminder: boolean, ecg: boolean, cameras: Array<{ __typename?: 'Camera', id: string, name: string, activatedAt: any | null, hardwareInfo: { __typename?: 'CameraHardwareInfo', imei: string, msisdn: string } }> };
